import { render, staticRenderFns } from "./m-bean-attribute.vue?vue&type=template&id=2a452178&"
import script from "./m-bean-attribute.vue?vue&type=script&lang=js&"
export * from "./m-bean-attribute.vue?vue&type=script&lang=js&"
import style0 from "./m-bean-attribute.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports